// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  checkoutUrl:'https://urcyv0ahcj.execute-api.eu-central-1.amazonaws.com/dev/create-checkout-session',
  getCheckoutSessionDetailsUrl: 'https://urcyv0ahcj.execute-api.eu-central-1.amazonaws.com/dev/get-checkout-session-details',
  getPaymentIntentDetailsUrl: 'https://urcyv0ahcj.execute-api.eu-central-1.amazonaws.com/dev/get-payment-intent-details',
  stripePublicKey: 'pk_test_51IReOOF1tZLoEwM37n9mOsD4C8CoCCGTsMqRDVJ5VPtctRFGB5Q2ELaRnNOTB0JI7qh2g96a83c78E9BWizGYTsZ00oeVoNqUx'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
